export const ERROR = 'endrosment/ERROR';
export const ENDROSMENT_LIST = 'endrosment/ENDROSMENT_LIST';
export const FLUSH = 'FLUSH';
export const MESSAGE = 'endrosment/MESSAGE';
export const ADD_ENDROSMENT = 'endrosment/ADD_ENDROSMENT';